var path = '/authoring-homepage-ui/publishingAtAGlance/publishingAtAGlanceOnHold/publishingAtAGlanceOnHold.html';
var html = "<div id=publishing-at-a-glance-on-hold> <div class=section-container> <p class=no-entries translate ng-if=\"$ctrl.entries.length === 0\">There are no publishing events on hold.</p> <publishing-at-a-glance-accordion entries=$ctrl.entries datesort=-date idprefix=o></publishing-at-a-glance-accordion> <div class=no-calendar-spacer ng-class=\"{'no-entries-empty-height':$ctrl.entries.length === 0}\"></div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/publishingAtAGlance/publishingAtAGlanceOnHold/publishingAtAGlanceOnHold.html
// module id = 93
// module chunks = 0